import { __awaiter, __generator } from "tslib";
import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
import { defineComponent, reactive, ref, watch } from 'vue';
import html2canvas from 'html2canvas';
import { logger } from '@/utils';
export default defineComponent({
  name: 'UserExamTicket',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup: function (props) {
    var _this = this;
    var daoService = useService(DaoService);
    var loading = ref(false);
    var resData = reactive({
      contestName: '',
      scheduleName: '',
      examStartTime: '',
      examEndTime: '',
      province: '',
      admissionTicket: '',
      name: '',
      sex: 0,
      schoolName: '',
      examPlace: '',
      seatNum: '',
      avatar: '',
      activityTerm: '',
      stageName: '',
      cardNo: '',
      title: ''
    });
    watch(function () {
      return props.data.visible;
    }, function (visible) {
      if (visible) {
        loading.value = true;
        daoService.getExamTicketInfo({
          userExamId: props.data.userExamId
        }).then(function (res) {
          Object.assign(resData, res);
        }).finally(function () {
          loading.value = false;
        });
      }
    });
    var onDownloadClick = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var el, images, canvas, imgData, fileName, a, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              el = document.getElementById('exam-ticket');
              if (!el) {
                return [2 /*return*/];
              }
              loading.value = true;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 4, 5, 6]);
              images = el.querySelectorAll('img');
              return [4 /*yield*/, Promise.all(Array.from(images).map(function (img) {
                return new Promise(function (resolve) {
                  if (img.complete) {
                    resolve(true);
                  } else {
                    img.onload = function () {
                      return resolve(true);
                    };
                    img.onerror = function () {
                      return resolve(false);
                    };
                  }
                });
              }))];
            case 2:
              _a.sent();
              return [4 /*yield*/, html2canvas(el, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
                logging: false
              })];
            case 3:
              canvas = _a.sent();
              imgData = canvas.toDataURL('image/png');
              fileName = '准考证.png';
              a = document.createElement('a');
              a.href = imgData;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              return [3 /*break*/, 6];
            case 4:
              e_1 = _a.sent();
              logger.error('生成准考证图片失败', e_1);
              return [3 /*break*/, 6];
            case 5:
              loading.value = false;
              return [7 /*endfinally*/];
            case 6:
              return [2 /*return*/];
          }
        });
      });
    };
    return {
      loading: loading,
      onDownloadClick: onDownloadClick,
      resData: resData
    };
  }
});